module.exports = __webpack_public_path__ + "static/pitch_nights_header-73ee03fa37a793a1eb14642c595e693d.png";